import styled from "styled-components";

export const InlineBlock = styled.div`
    display: inline-block;
`;

export const DetailsName = styled.div`
    color: var(--Basic-900);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 4px;
`;

export const DetailsDescription = styled.div`
    color: var(--Grey-700);
    font-size: 14px;
    font-weight: 300;
    letter-spacing: -0.34px;
    line-height: 20px;
    margin-bottom: 36px;
`;